/**
 * Get / setthe specified cache value.
 *
 * @param {string} key
 * @param {object} value
 * @returns
 */
export const cache = (key = null, value = null) => {
  if (key == null) {
    return new Cache();
  }

  let instance = new Cache();

  if (value == null) {
    return instance.get(key);
  }

  return instance.put(key, value);
}

export default class Cache {
  constructor() { }

  /**
   * Get an item from the cache by key.
   *
   * @param {string} key
   * @param {object} defaultValue
   * @returns
   */
  get(key, defaultValue = null) {
    const value = localStorage.getItem(key);

    return value !== null ? JSON.parse(value) : defaultValue;
  }

  /**
   * Remove the item with the corresponding key in cache.
   *
   * @param {string} key
   * @returns
   */
  forget(key) {
    localStorage.removeItem(key);

    return this;
  }

  /**
   * Add an item in the cache under the given key.
   *
   * @param {string} key
   * @param {object} value
   * @returns
   */
  put(key, value) {
    localStorage.setItem(
      key,
      JSON.stringify(value)
    );

    return this;
  }
}